import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@core/modals/modal-registry.token';
import { TradeModalComponent } from '@core/modals/trade-modal/trade-modal.component';
import { IFrameModal } from '@core/modals/iframe-modal/iframe-modal.component';
import { OurDepositsModalComponent } from '@core/modals/our-deposits-modal/our-deposits-modal.component';
import { AutoBetLeaveConfirmComponent } from '@core/modals/autobet-leave-confirm/autobet-leave-confirm.component';

export function provideSharedModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'TradeModal', component: TradeModalComponent, requiresAuth: true }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'IFrameModal', component: IFrameModal, requiresAuth: true }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'OurDepositsModal', component: OurDepositsModalComponent }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'AutoBetLeaveConfirm', component: AutoBetLeaveConfirmComponent }, multi: true },
  ];
}
